import { render } from "./PortfolioGraphicDesign.vue?vue&type=template&id=65d612cd"
import script from "./PortfolioGraphicDesign.vue?vue&type=script&lang=js"
export * from "./PortfolioGraphicDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__